import React, { useEffect, useState } from 'react'
import { IconPlus } from "@tabler/icons-react";
// import StepperNavigationButtons from '../../../../MyInvitations/Common/StepperNavigationButtons';
import Records from './Records';
import StepperNavigationButtons from '../../../MyInvitations/Common/StepperNavigationButtons';

export default function Record(props, ref) {
      const [records, setRecords] = useState([]);
      const [recordsData, setRecordsData] = useState([]);
      // const handleDataClick = (data) => {
      //  props.Data(data)
      // };
      const handleAddEvent = () => {
        let event = {
          title: "Video url " + (records.length + 1),
          noOfRecords: undefined,
          venue: "",
          show: true,
          ref: null,
        };
      
        setRecords((currentEvents) => {
          currentEvents.forEach((event) => {
            event["show"] = false;
          });
      
          let newEvent = [...currentEvents, event];
      
          console.log("Updated Records:", newEvent.flatMap(ev => ev.ref?.getData() || []));
          setRecordsData(newEvent.map(ev => ev.ref?.getData()))
          return newEvent;
        });
      };
      
props.Data(recordsData)
      const showHideEvent = (index) => {
        const currentEvents = [...records];
    
        currentEvents.forEach((event, innerIndex) => {
          if (index == innerIndex) event["show"] = !event["show"];
          else event["show"] = false;
        });
    
        setRecords(currentEvents);
      };


      const deleteEventHandler = (targetIndex) => {
        const filteredEvents = records.filter(
          (item, index) => index !== targetIndex
        );
    
        if (filteredEvents.length == 1) {
          filteredEvents[0]["show"] = true;
        } else {
          filteredEvents.forEach((event, index) => {
            if (index == targetIndex - 1) event["show"] = true;
          });
        }
        setRecords(filteredEvents);
      };
console.log("recordsData",recordsData)

  return (
    <div className="card accordion-item">
  
    <div>
      <div className="accordion-body mt-3">
        <div className="content-header mb-3 d-flex justify-content-between">
          <div className="sec-titler">

          </div>
          <div className="mb-0 text-right">
            <button
            type="button"
              className="btn btn-primary align-middle"
              onClick={handleAddEvent}
            >
              <IconPlus className="me-sm-1 me-0" size={20} />
              Add Video url
            </button>
          </div>
        </div>

        {records &&
          records.length > 0 &&
          records.map((event, index) => {
            return (
              <Records
                data={event}
                index={index}
                showHideEvent={showHideEvent}
                deleteEvent={deleteEventHandler}
                key={index}
                ref={(el) => (event.ref = el)}
                showDelete={true}
                // Data={handleDataClick}
              />
            );
          })}
        <StepperNavigationButtons
          index={props.index}
          steps={props.steps}
          navigate={props.navigate}
          onClick={handleAddEvent}
        />
      </div>
    </div>
  </div>
  )
}


